<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    subTitle: string
    formUrl?: string
  }>(),
  {
    subTitle: undefined,
    formUrl: undefined,
  },
)
</script>

<template>
  <section
    class="mb-4 w-full rounded-xl bg-[--theme-lighter] p-4 sm:p-6 md:m-4 md:w-[735px] md:p-12"
  >
    <h2
      class="pb-4 font-national2condensed text-marketing-mobile-h2-h2-medium text-[--theme-dark] md:text-marketing-desktop-h2-h2-medium"
    >
      {{ title }}
    </h2>
    <p v-if="subTitle" class="font-national2 text-[--theme-darker]">
      {{ subTitle }}
    </p>
    <iframe
      v-if="formUrl"
      class="h-[540px] w-full border-none pt-12 md:h-[480px]"
      :src="formUrl"
    />
    <p v-else class="pt-12">
      Vi har dessverre ikke lagt ut interesseskjemaet for dette
      produktet, prøv igjen senere.
    </p>
  </section>
</template>
